/**
 * My Volkswagen (MyVW) Loader
 */

import React from 'react'
import styled from 'styled-components'

const StyledLoading = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 200px;
  padding-bottom: 200px;
`

const Spinner = styled.div`
  display: inline-block;
  width: 64px;
  height: 64px;
  &:after {
    content: ' ';
    display: block;
    width: 46px;
    height: 46px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #001e50;
    border-color: #001e50 transparent #001e50 transparent;
    animation: ngw-spinner-fx 1.2s linear infinite;
  }
  @keyframes ngw-spinner-fx {
    0% {
      transform: rotate(0deg);
      opacity: 0.4;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotate(360deg);
      opacity: 0.2;
    }
  }
`

export default props => (
  <StyledLoading {...props}>
    <Spinner />
  </StyledLoading>
)
